import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import { DateTime } from 'scaleflow/utils/date-time';

class TeamsTeamCheckInArchiveQuestionsRoute extends Route {
  @service store;
  @service router;

  today = DateTime.now().add(2, 'days').format('YYYY-MM-DD');
  two_weeks_ago = DateTime.now().subtract(12, 'weeks').format('YYYY-MM-DD');

  setupController(controller, model) {
    super.setupController(controller, model);
    this.store
      .findAll('person')
      .then((results) => controller.set('usersModel', results));
  }

  async model() {
    const param = this.paramsFor(
      this.router.currentURL.includes('teams')
        ? 'operations.teams.team'
        : 'initiatives.initiative',
    );

    try {
      let archivedQuestions = await this.store.query('question', {
        filter: {
          archived: true,
          after: this.two_weeks_ago,
          before: this.today,
          ...param,
        },
      });
      let uniqueDates = this.groupByDate(archivedQuestions, 'created_at');
      let orderedDates = this.orderDates(uniqueDates);
      if (Object.keys(orderedDates).length === 0) {
        return { data: false, parent_id: Object.values(param)[0] };
      } else {
        let formattedDates = this.formatDates(orderedDates);
        return { data: formattedDates, parent_id: Object.values(param)[0] };
      }
    } catch (err) {
      console.log(err);
      if (err?.errors?.[0]?.status === '404') {
        this.router.transitionTo('/teams');
      }
    }
  }

  formatDates(object) {
    for (const key in object) {
      let momentFormat = DateTime.from(key).calendar({
        sameDay: '[Today]',
        lastDay: '[Yesterday]',
        lastWeek: 'ddd, DD MMM YYYY',
        sameElse: 'ddd, DD MMM YYYY',
      });
      delete Object.assign(object, { [momentFormat]: object[key] })[key];
    }
    return object;
  }

  groupByDate(array, key) {
    return array.reduce(function (rv, x) {
      const dateKey = DateTime.from(x.get(key)).format('YYYY-MM-DD');
      (rv[dateKey] = rv[dateKey] || []).push(x);
      return rv;
    }, {});
  }

  orderDates(unordered) {
    return Object.keys(unordered)
      .sort()
      .reverse()
      .reduce((obj, key) => {
        obj[key] = unordered[key];
        return obj;
      }, {});
  }
}

export default instrumentRoutePerformance(
  TeamsTeamCheckInArchiveQuestionsRoute,
);
